import React, { useEffect, useState } from 'react';
import { Box, Typography, Card, Snackbar, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { api } from './suministros/api';

import Hero from '../components/Hero';
import BusinessIcon from '@mui/icons-material/Business';
import SuministrosUsuario from '../components/suministrosUsuario';
import AddSupplyForm from '../components/addSuplyForm';

const Dashboard = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const [suministros, setSuministros] = useState([]);

  // feedback
  const [successOpen, setSuccessOpen] = useState(false);
  const [errorOpen, setErrorOpen] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const fetchSupplies = async () => {
    try {
      const res = await api.suministro.getByUsuario(user.Id);
      setSuministros(res || []);
    } catch (err) {
      console.error("Error al cargar suministros:", err);
    }
  };

  useEffect(() => {
    fetchSupplies();
  }, []);

  // 👉 misma lógica que AddSupply
  const handleAddSupply = async ({ cliCod, sumNro, docTipo, docNumero }) => {
    try {
      await api.suministro.addSupply({
        usuarioId: user.Id,
        cliCod: parseInt(cliCod, 10),
        sumNro: parseInt(sumNro, 10),
        docTipo,
        docNumero
      });

      setSuccessOpen(true);

      // refrescar lista
      await fetchSupplies();

    } catch (e) {
      setErrorMsg(e.message || "Ocurrió un error en el servidor. Intentá nuevamente.");
      setErrorOpen(true);
    }
  };

  return (
    <>
      <Hero>
        <Card
          sx={{
            p: 3,
            mb: 4,
            borderRadius: 3,
            bgcolor: '#64AE37',
            color: 'white',
            boxShadow: 4,
            textAlign: 'center',
          }}
        >
          <Typography
            variant="h4"
            fontWeight="bold"
            mb={1}
            sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1 }}
          >
            <BusinessIcon fontSize="inherit" />
            Oficina Virtual
          </Typography>

          <Typography variant="h6">
            Bienvenido/a{" "}
            <Box component="span" fontWeight="bold">
              {user.nombre}
            </Box>
            .
          </Typography>
        </Card>
      </Hero>

      <Box p={2} maxWidth={900} mx="auto">
        {suministros.length === 0 ? (
          <>
            <Typography
              variant="body1"
              color="text.secondary"
              mb={2}
              textAlign="center"
            >
              No tenés ningún suministro registrado. Agregá uno para empezar a gestionarlo
              y aprovechar todas las funcionalidades de la app.
            </Typography>

            <AddSupplyForm
              onSubmit={handleAddSupply}
              cancelCallback={() => navigate("/dashboard")}
            />
          </>
        ) : (
          <SuministrosUsuario suministros={suministros} />
        )}
      </Box>

      {/* SUCCESS */}
      <Snackbar
        open={successOpen}
        autoHideDuration={3000}
        onClose={() => setSuccessOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSuccessOpen(false)}
          severity="success"
          sx={{ width: "100%" }}
        >
          Suministro agregado correctamente
        </Alert>
      </Snackbar>

      {/* ERROR */}
      <Snackbar
        open={errorOpen}
        autoHideDuration={5000}
        onClose={() => setErrorOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setErrorOpen(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {errorMsg}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Dashboard;
